export default __webpack_public_path__ + "static/media/IconDesc_Leaves.256.37148e47.png";